import { modifyCollectionWithId } from './utils';
import { EShareModalActionTypes } from '../../actions/shareCollection';
import { TReduxActions } from '../../types/redux';
import { IShareCollectionState } from '../../types/shareCollection';

const initialState: IShareCollectionState = {
  enabled: false,
  openedId: null,
  shares: [],
  tooltip: { text: null, state: 'hide' },
};

export const shareCollectionReducer = (
  state: IShareCollectionState = initialState,
  action: TReduxActions,
): IShareCollectionState => {
  switch (action.type) {
    case EShareModalActionTypes.Set:
      return {
        ...state,
        shares: modifyCollectionWithId(action.payload.id, state.shares, undefined, {
          name: action.payload.name,
          hideContacts: action.payload.hideContacts,
          hideNotes: action.payload.hideNotes,
          hideAddresses: action.payload.hideAddresses,
          hideOffersLink: action.payload.hideOffersLink,
          url: action.payload.url,
        }),
      };
    case EShareModalActionTypes.Open:
      return {
        ...state,
        openedId: action.payload.id,
        shares: modifyCollectionWithId(action.payload.id, state.shares, undefined, {
          name: action.payload.name,
        }),
      };
    case EShareModalActionTypes.Close:
      return {
        ...state,
        openedId: null,
      };
    case EShareModalActionTypes.SetName:
      return {
        ...state,
        shares: modifyCollectionWithId(action.payload.id, state.shares, { name: action.payload.value }),
      };
    case EShareModalActionTypes.SetHideNotes:
      return {
        ...state,
        shares: modifyCollectionWithId(action.payload.id, state.shares, { hideNotes: action.payload.value }),
      };
    case EShareModalActionTypes.SetHideContacts:
      return {
        ...state,
        shares: modifyCollectionWithId(action.payload.id, state.shares, { hideContacts: action.payload.value }),
      };
    case EShareModalActionTypes.SetHideOffersLiks:
      return {
        ...state,
        shares: modifyCollectionWithId(action.payload.id, state.shares, { hideOffersLink: action.payload.value }),
      };
    case EShareModalActionTypes.SetHideAddresses:
      return {
        ...state,
        shares: modifyCollectionWithId(action.payload.id, state.shares, { hideAddresses: action.payload.value }),
      };
    case EShareModalActionTypes.SetShareType:
      return {
        ...state,
        shares: modifyCollectionWithId(action.payload.id, state.shares, { shareType: action.payload.value }),
      };
    case EShareModalActionTypes.SetUrl:
      return {
        ...state,
        shares: modifyCollectionWithId(action.payload.id, state.shares, { url: action.payload.value }),
      };

    case EShareModalActionTypes.SetIsFetching:
      return {
        ...state,
        shares: modifyCollectionWithId(action.payload.id, state.shares, { isFetching: action.payload.isFetchingType }),
      };
    case EShareModalActionTypes.SetShareTooltip:
      return {
        ...state,
        tooltip: action.payload,
      };

    case EShareModalActionTypes.SetShareSettings:
      return {
        ...state,
        shares: modifyCollectionWithId(action.payload.id, state.shares, {
          name: action.payload.name,
          hideContacts: action.payload.hideContacts,
          hideNotes: action.payload.hideNotes,
          hideAddresses: action.payload.hideAddresses,
          hideOffersLink: action.payload.hideOffersLink,
          url: action.payload.url,
        }),
      };

    default:
      return state;
  }
};
